import * as Yup from 'yup'

import { FormItemProps } from '@/components/Form/types'
import { settingsConfigHelp } from '@/components/Settings/configHelp'

const positiveInteger = () =>
  Yup.number()
    .transform((value, originalValue) => (originalValue === '' ? undefined : value))
    .typeError('Enter a valid number')
    .integer('Enter a whole number')
    .min(1, 'Must be at least 1')
    .required('Required')

const numberInput = (name: string, label: string, help: string): FormItemProps => ({
  name,
  label,
  help,
  type: 'Number',
  validation: positiveInteger(),
  classNames: {
    container: 'col-span-12 sm:col-span-6',
  },
  itemOptions: {
    min: 1,
    step: 1,
  },
})

export const customizationElementSettingsFormItems: FormItemProps[] = [
  {
    name: 'elementSizeSection',
    type: 'Label',
    classNames: {
      container: 'col-span-12 !min-h-0',
      content: 'text-title-md text-gray-900',
    },
    itemOptions: {
      description: 'Default Element Width (% of section width)',
    },
  },
  numberInput('textElementSize', 'Text', settingsConfigHelp.elementSize.text),
  numberInput('graphicElementSize', 'Graphic', settingsConfigHelp.elementSize.graphic),
  numberInput('aiImageElementSize', 'AI Image', settingsConfigHelp.elementSize.aiImage),
  numberInput('monogramElementSize', 'Monogram', settingsConfigHelp.elementSize.monogram),
  numberInput('uploadGraphicElementSize', 'Upload Graphic', settingsConfigHelp.elementSize.uploadGraphic),
  {
    name: 'minimumResolutionSection',
    type: 'Label',
    classNames: {
      container: 'col-span-12 !min-h-0 border-t border-gray-200 pt-xl mt-md',
      content: 'text-title-md text-gray-900',
    },
    itemOptions: {
      description: 'Minimum Uploaded Image Resolution (px)',
    },
  },
  numberInput('minimumResolutionWidth', 'Width', settingsConfigHelp.minimumResolution.width),
  numberInput('minimumResolutionHeight', 'Height', settingsConfigHelp.minimumResolution.height),
]
